  import axios from '@/utils/request'
  export default {
  downloadTemplate(filename) {
     axios({
         method: "get",
         url: `/ww_01/sys/user/downloadTemplate`,
         responseType: "arraybuffer"
       })
       .then(
         function (response) {
          this.fileDownload(response.data, filename);
         }.bind(this)
       )
       .catch(
         function (error) {
           alert("网络请求出错");
         }.bind(this)
       );
   },
  fileDownload(data, fileName) {
     let blob = new Blob([data], {
       type: "application/octet-stream"
     });
     let filename = fileName || "filename.xls";
     if (typeof window.navigator.msSaveBlob !== "undefined") {
       window.navigator.msSaveBlob(blob, filename);
     } else {
       var blobURL = window.URL.createObjectURL(blob);
       var tempLink = document.createElement("a");
       tempLink.style.display = "none";
       tempLink.href = blobURL;
       tempLink.setAttribute("download", filename);
       if (typeof tempLink.download === "undefined") {
         tempLink.setAttribute("target", "_blank");
       }
       document.body.appendChild(tempLink);
       tempLink.click();
       document.body.removeChild(tempLink);
       window.URL.revokeObjectURL(blobURL);
     }
   }
  }
  


// WEBPACK FOOTER //
// ./src/utils/downloadFile.js